import React from "react";
import Seo from "../components/Seo";
import Content from "../views/Legals/Content";
import Hero from "../views/Legals/Hero";

const LegalsPage = () => {
  return (
    <React.Fragment>
      <Seo title="Mentions légales" />
      <Hero />
      <Content />
    </React.Fragment>
  );
};

export default LegalsPage;
